import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { SettingsManager } from '@atlas/core';

export default function CustomStylesPortal() {
  const styleElement = document.getElementById('custom-styles');
  const [outsideData, setOutsideData] = useState({});

  useEffect(() => {
    const receiveMessage = event => {
      if (event?.data?.type === 'STYLES_DATA') {
        const { code, colors, theme } = event.data.payload;
        setOutsideData({ code, colors, theme });
      }
    };

    window.addEventListener('message', receiveMessage);

    return () => window.removeEventListener('message', receiveMessage);
  }, []);

  useEffect(() => {
    const { theme } = outsideData;
    if (theme) {
      SettingsManager.updateSettings({ theme });
    }
  }, [outsideData.theme]);

  if (!styleElement) return null;

  return createPortal(
    <>
      {outsideData.colors}
      {outsideData.code}
    </>,
    styleElement,
  );
}
